import { atom } from 'jotai/vanilla';
import type { UserId } from 'balus-common';

// フォロー中のユーザーID（null = フォローなし）
export const followingUserIdAtom = atom<UserId | null>(null);
